<template>
    <div>
        <div class="col-11 mx-auto">
            <h2 class="text-primary font-weight-bold mb-4">La gente dice</h2>
        </div>
        <div class="col-12" id="carousel-comment">
            <!--<carousel :items="2" :nav="false" :mouseDrag="false" :stagePadding="100" :loop="true" :margin="15"-->
            <carousel
                :responsive="{
                    0:{items:1,nav:false,mouseDrag:true},
                    600:{items:1,nav:false,mouseDrag:true,stagePadding:100,loop:true,margin:15},
                    800:{items:2,nav:false,mouseDrag:true,stagePadding:100,loop:true,margin:15}
                }">

                <div class="col-12 card-comments p-3 my-1" v-for="(comment, i) in comments"
                    :key="i">
                    <div class="row">
                        <div class="col-3 col-lg-2">
                            <img v-if="comment.Media" :src="comment.Media.full_url" alt="foto-cliente" style="border-radius: 100px; aspect-ratio: 1/1;">
                            <img v-else src="../../assets/images/prueba_perfil_comentario_2.png" alt="foto-cliente">
                        </div>
                        <div class="col-9 col-lg-10">
                            <span class="text-primary font-weight-bold" style="font-size: 20px;">{{ comment.name }}</span>
                            <br>
                            <span class="color-palette-3">{{ comment.Project.name }}</span>
                        </div>
                    </div>
                    <hr class="my-2">
                    <div class="col px-0 px-lg-3">
                        <span class="text-justify" style="color: #707070 !important" v-html="comment.comment"></span>
                    </div>
                </div>


            </carousel>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CommentsHome",
        props: ['comments'],
        data() {
            return {

            }
        },
    }
</script>

<style>

</style>
